/*
 * Club Kit Bundle Wizard
 * OMG-style per-item flow: preview card → steps (size/qty/custom fields)
 * → estimated subtotal → one atomic /cart/add.js call.
 * State lives in the DOM. Dirty rule: any change to a saved step un-saves
 * it, so at add time live controls always equal last-saved state and
 * buildItems can safely read the DOM.
 * Mirrors custom-options.js conventions (`_customization_link`, fee
 * variants); fee lines get quantity equal to their parent line's qty.
 */
(function($) {
  'use strict';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.PXUTheme && window.PXUTheme.money_format) {
      return window.Shopify.formatMoney(cents, window.PXUTheme.money_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  var BundleWizard = {
    init: function() {
      var self = this;
      var $all = $('[data-kit-builder]');
      $all.each(function() {
        self.initKit($(this), $all);
      });
    },

    initKit: function($kit, $all) {
      var self = this;

      $kit.find('[data-kit-open]').on('click', function() {
        $all.not($kit).each(function() { self.collapse($(this)); });
        $kit.addClass('is-open');
        $kit.find('[data-kit-preview]').prop('hidden', true);
        $kit.find('[data-kit-wizard]').prop('hidden', false);
        if (!$kit.find('[data-kit-step].is-active').length) {
          var $first = self.firstIncomplete($kit);
          if ($first.length) self.openStep($kit, $first);
        }
        $kit[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      $kit.on('click', '[data-step-toggle]', function() {
        self.openStep($kit, $(this).closest('[data-kit-step]'));
      });

      $kit.on('click', '[data-qty-minus], [data-qty-plus]', function() {
        var $input = $(this).siblings('[data-kit-qty]');
        var min = parseInt($input.attr('min'), 10) || 1;
        var val = parseInt($input.val(), 10) || min;
        val += $(this).is('[data-qty-plus]') ? 1 : -1;
        $input.val(Math.max(val, min));
        $input.trigger('change');
      });

      // Dirty rule: any change inside a saved step un-saves it.
      $kit.on('change input', '[data-kit-step] select, [data-kit-step] input', function(e) {
        var $step = $(this).closest('[data-kit-step]');
        if ($step.hasClass('is-saved')) {
          self.unsave($kit, $step);
        }
        if ($(this).is('[data-kit-qty]')) {
          var $qty = $(this);
          var min = parseInt($qty.attr('min'), 10) || 1;
          var raw = $qty.val();
          var isEmpty = $.trim(raw) === '';
          var val = parseInt(raw, 10);
          var clamped = (isNaN(val) || val < min) ? min : val;
          // Skip write-back while the user is mid-typing an empty field (lets clear-then-type work);
          // a 'change' (blur) event always clamps regardless.
          if (clamped !== val && !(isEmpty && e.type === 'input')) {
            $qty.val(clamped);
          }
        }
        self.refresh($kit);
      });

      $kit.on('click', '[data-step-save]', function() {
        self.saveStep($kit, $(this).closest('[data-kit-step]'));
      });

      $kit.find('[data-kit-add]').on('click', function() {
        self.addBundle($kit, $(this));
      });

      $kit.find('[data-kit-again]').on('click', function() {
        self.rearm($kit);
      });

      self.refresh($kit);
    },

    collapse: function($kit) {
      $kit.removeClass('is-open');
      $kit.find('[data-kit-wizard]').prop('hidden', true);
      $kit.find('[data-kit-preview]').prop('hidden', false);
      if ($kit.find('[data-kit-step].is-saved').length) {
        $kit.find('[data-kit-open]').text('Resume Bundle');
      }
    },

    firstIncomplete: function($kit) {
      return $kit.find('[data-kit-step]').not('.is-saved').first();
    },

    openStep: function($kit, $step) {
      if (!$step || !$step.length) return;
      $kit.find('[data-kit-step]').each(function() {
        var $s = $(this);
        var isTarget = $s.is($step);
        $s.toggleClass('is-active', isTarget);
        $s.find('[data-step-body]').prop('hidden', !isTarget);
        $s.find('[data-step-toggle]').attr('aria-expanded', isTarget ? 'true' : 'false');
      });
    },

    unsave: function($kit, $step) {
      $step.removeClass('is-saved');
      $step.find('[data-step-status]').text('○');
      $step.find('[data-step-status-text]').text('Not started');
      $step.find('[data-step-summary]').text('');
      $step.find('[data-step-edit]').prop('hidden', true);
      this.resetSuccess($kit);
    },

    summaryFor: function($step) {
      var parts = [];
      var $variant = $step.find('[data-kit-variant]');
      if ($variant.is('select')) {
        parts.push($.trim($variant.find('option:selected').text()));
      }
      var min = parseInt($step.attr('data-min-qty'), 10) || 1;
      var qty = parseInt($step.find('[data-kit-qty]').val(), 10);
      if (isNaN(qty) || qty < min) qty = min;
      parts.push('Qty ' + qty);
      $step.find('input[data-custom-field]').each(function() {
        var val = $.trim($(this).val());
        if (val !== '') {
          parts.push($(this).is('[data-custom-field="number"]') ? '#' + val : val);
        }
      });
      return parts.join(' · ');
    },

    validateStep: function($step) {
      var $error = $step.find('[data-step-error]');
      $error.prop('hidden', true).text('');

      var $variant = $step.find('[data-kit-variant]');
      if (!$variant.val()) {
        $error.text('Please select a size.').prop('hidden', false);
        return false;
      }

      var valid = true;
      $step.find('[data-custom-options] input[required]').each(function() {
        var $input = $(this);
        $input.removeClass('custom-options__error');
        $input.siblings('.custom-options__error-message').remove();
        if ($.trim($input.val()) === '') {
          valid = false;
          $input.addClass('custom-options__error');
          $input.after('<p class="custom-options__error-message">This field is required</p>');
        }
      });
      if (!valid) {
        $error.text('Please fill in the required fields.').prop('hidden', false);
      }
      return valid;
    },

    saveStep: function($kit, $step) {
      if (!this.validateStep($step)) return;
      $step.addClass('is-saved');
      $step.find('[data-step-status]').text('✓');
      $step.find('[data-step-status-text]').text('Completed');
      $step.find('[data-step-summary]').text(this.summaryFor($step));
      $step.find('[data-step-edit]').prop('hidden', false);
      this.announce($kit, $step.attr('data-step-title') + ' saved.');

      var $next = this.firstIncomplete($kit);
      if ($next.length) {
        this.openStep($kit, $next);
      } else {
        $step.removeClass('is-active');
        $step.find('[data-step-body]').prop('hidden', true);
        $step.find('[data-step-toggle]').attr('aria-expanded', 'false');
        this.announce($kit, 'All items complete. Ready to add bundle to cart.');
      }
      this.refresh($kit);
    },

    // Recompute sidebar lines, subtotal, progress, and Add state.
    refresh: function($kit) {
      var total = 0;
      var savedCount = 0;
      var $steps = $kit.find('[data-kit-step]');
      var $lines = $kit.find('[data-sidebar-line]');

      $steps.each(function(index) {
        var $step = $(this);
        var $variant = $step.find('[data-kit-variant]');
        var price;
        if ($variant.is('select')) {
          var $opt = $variant.find('option:selected');
          price = parseInt($opt.attr('data-price'), 10);
        } else {
          price = parseInt($variant.attr('data-price'), 10);
        }
        if (isNaN(price)) price = parseInt($step.attr('data-min-price'), 10) || 0;

        var min = parseInt($step.attr('data-min-qty'), 10) || 1;
        var qty = parseInt($step.find('[data-kit-qty]').val(), 10);
        if (isNaN(qty) || qty < min) qty = min;

        var lineTotal = price * qty;
        total += lineTotal;
        if ($step.hasClass('is-saved')) savedCount++;

        var $line = $lines.eq(index);
        $line.find('[data-line-qty]').text(qty);
        $line.find('[data-line-price]').text(formatMoney(price));
        $line.find('[data-line-total]').text(formatMoney(lineTotal));
      });

      var allSaved = savedCount === $steps.length && $steps.length > 0;
      $kit.find('[data-kit-total]').text(formatMoney(total));
      $kit.find('[data-kit-subtotal-label]').text(allSaved ? 'Bundle Subtotal' : 'Estimated Bundle Subtotal');
      $kit.find('[data-kit-progress]').text(savedCount + ' of ' + $steps.length + ' complete');

      var success = $kit.hasClass('is-added');
      $kit.find('[data-kit-add]')
        .prop('disabled', !allSaved || success)
        .toggleClass('disabled', !allSaved || success);
    },

    buildItems: function($kit) {
      var items = [];

      $kit.find('[data-kit-step]').each(function(index) {
        var $step = $(this);
        var variantId = parseInt($step.find('[data-kit-variant]').val(), 10);
        if (!variantId) return;

        var min = parseInt($step.attr('data-min-qty'), 10) || 1;
        var qty = parseInt($step.find('[data-kit-qty]').val(), 10);
        if (isNaN(qty) || qty < min) qty = min;

        var $options = $step.find('[data-custom-options]');
        var properties = {};
        var hasProps = false;

        $options.find('input[data-custom-field]').each(function() {
          var val = $.trim($(this).val());
          if (val !== '') {
            properties[$(this).attr('name').replace('properties[', '').replace(']', '')] = val;
            hasProps = true;
          }
        });

        var linkId = variantId + '-' + Date.now() + '-' + index;
        var item = { id: variantId, quantity: qty };
        if (hasProps) {
          properties['_customization_link'] = linkId;
          item.properties = properties;
        }
        items.push(item);

        // Fee items — same rules as custom-options.js, qty mirrors parent line
        var isAddon = $options.data('custom-addon') === true || $options.data('custom-addon') === 'true';
        if (hasProps && isAddon) {
          var lastNameVal = $.trim($options.find('[data-custom-field="last-name"]').val() || '');
          var numberVal = $.trim($options.find('[data-custom-field="number"]').val() || '');
          var initialsVal = $.trim($options.find('[data-custom-field="initials-or-number"]').val() || '');
          var lastnameVariantId = $options.data('lastname-fee-variant-id');
          var numberVariantId = $options.data('number-fee-variant-id');

          if (lastNameVal !== '' && lastnameVariantId) {
            items.push({ id: parseInt(lastnameVariantId, 10), quantity: qty, properties: { '_customization_link': linkId } });
          }
          if ((numberVal !== '' || initialsVal !== '') && numberVariantId) {
            items.push({ id: parseInt(numberVariantId, 10), quantity: qty, properties: { '_customization_link': linkId } });
          }
        }
      });

      return items;
    },

    addBundle: function($kit, $btn) {
      var self = this;
      var $error = $kit.find('[data-kit-error]');
      $error.prop('hidden', true).text('');

      var items = self.buildItems($kit);
      if (items.length === 0) return;

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        contentType: 'application/json',
        data: JSON.stringify({ items: items }),
        beforeSend: function() {
          $btn.prop('disabled', true).addClass('disabled').text('Adding…');
        },
        success: function() {
          // Persistent success state — no auto-reset (prevents accidental duplicates)
          $kit.addClass('is-added');
          $btn.text('Added to Cart ✓');
          $kit.find('[data-kit-success]').prop('hidden', false);
          self.announce($kit, 'Bundle added to cart.');

          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success: function(cart) {
              setTimeout(function() {
                if (typeof window.refreshCart === 'function') {
                  window.refreshCart(cart);
                }
                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                  $('.rightlogin .cart-container').addClass('active_link');
                  $('.mobnavright .cart-container').addClass('active_link');
                }
              }, 500);
            }
          });
        },
        error: function(xhr) {
          var response;
          try { response = JSON.parse(xhr.responseText); } catch (e) { response = { description: 'Unable to add bundle to cart' }; }
          $error.text(response.description).prop('hidden', false);
          self.announce($kit, 'Could not add bundle: ' + response.description);
          $btn.text('Add Bundle to Cart');
          self.refresh($kit);
        }
      });
    },

    resetSuccess: function($kit) {
      if (!$kit.hasClass('is-added')) return;
      $kit.removeClass('is-added');
      $kit.find('[data-kit-success]').prop('hidden', true);
      $kit.find('[data-kit-add]').text('Add Bundle to Cart');
    },

    rearm: function($kit) {
      this.resetSuccess($kit);
      this.announce($kit, 'Ready to add another bundle.');
      this.refresh($kit);
    },

    announce: function($kit, message) {
      $kit.find('[data-kit-live]').text(message);
    }
  };

  $(function() {
    if (document.querySelector('[data-kit-builder]')) {
      BundleWizard.init();
    }
  });

})(jQuery);
